export const actionType = {
    selectContributors: "SELECT_ALL_CONTRIBUTORS",
    timeRegistrationByContributor: "SELECT_TIME_REGISTRATION_BY_CONTRIBUTOR",
    selectPointRegisterByParametrization: "SELECT_POINT_REGISTER_BYpARAMETRIZATION",
};
